// extracted by mini-css-extract-plugin
export default {"root":"sticky-container_root__hTM5f"};